import { useEffect, useState } from "react";
import { getInstagramConfig } from "./service";

function useInstagramConfiguration(workspaceId) {
  const [instagramConfiguration, setInstagramConfiguration] = useState({
    data: null,
    loading: true,
    isConfigured: false,
  });

  const fetchInstagramConfiguration = async (workspaceId) => {
    setInstagramConfiguration((prevState) => ({ ...prevState, loading: true }));
    try {
      const response = await getInstagramConfig({ workspaceId });
      const data = response.data;
      setInstagramConfiguration({ data, loading: false, isConfigured: true });
    } catch (error) {
      const response = error.response;
      if (response.status === 404) {
        setInstagramConfiguration((prevState) => ({
          ...prevState,
          loading: false,
          isConfigured: false,
        }));
      }
      console.error(error);
    }
  };

  useEffect(() => {
    if (workspaceId) {
      fetchInstagramConfiguration(workspaceId);
    }
  }, [workspaceId]);

  return {
    instagramConfiguration,
    fetchInstagramConfiguration,
  };
}

export { useInstagramConfiguration };
